export const config = {
  title: "sportilink",
  websiteIconOnly: 'https://dglstorage.com/files/sportilink/images/icon-transparent-48x48.png',
  defaultFeaturedImage: "https://dglstorage.com/files/sportilink/images/featured-square.png",

  // Phone OTP
  phoneOTPExpiration: 15 * 60 * 1000, // 15 minutes
  phoneOTPRetryAfter: 60 * 1000, // 1 minute
  phoneConfirmationExpiration: 15 * 60 * 1000, // 15 minutes

  // Email
  emailConfirmationExpiration: 15 * 60 * 1000, // 15 minutes

  // Auth
  authTokenExpiration: 365 * 24 * 60 * 60 * 1000, // 1 year
  adminLoginTokenExpiration: 24 * 60 * 60 * 1000, // 24 hours

  // Data List
  dataTake: 10,
  listingPeriod: 60 * 24 * 60 * 60 * 1000, // 60 days

  // File uploads
  maxFileSize: 2 * 1024 * 1024, // 2MB
  maxImageWidth: 1080,
  maxImageHeight: 1080,

  // Account
  usernameMinLength: 8,
  usernameMaxLength: 20,
  maxBioLength: 250,

  // Geolocation
  getLocationEvery: 5 * 60 * 1000, // 5 minutes
  locationRadius: 1000000000, // 1000000 km

  // Nearby search (clubs, sessions, venues, coaches, tournaments, events)
  // Radius is expressed in km; 0 means "No limit" (maps to locationRadius).
  nearbyRadiusOptions: [50, 200, 1000, 0] as const,
  // Normal users are pinned to this radius on all lists EXCEPT venues &
  // tournaments (where they may widen it). Admins can change it everywhere.
  nearbyDefaultRadius: 50, // km

  // Venue
  venueNameMinLength: 3,
  venueNameMaxLength: 100,
  venueDescriptionMaxLength: 2000,
  maxVenueImages: 10,

  // Court
  courtNameMinLength: 2,
  courtNameMaxLength: 100,
  maxCourtImages: 5,

  // Club
  clubNameMinLength: 3,
  clubNameMaxLength: 50,
  clubDescriptionMaxLength: 1000,
  defaultClubLogo: 'https://dglstorage.com/files/sportilink/images/club.png',
  clubBannerWidth: 1200,
  clubBannerHeight: 400,
  clubGalleryImageMaxWidth: 1080,
  clubGalleryImageMaxHeight: 1080,
  maxClubGalleryImages: 10,
  
  // Match
  matchSessionNameMinLength: 3,
  matchSessionNameMaxLength: 50,
  matchSessionDescriptionMaxLength: 1000,
  defaultMatchSessionLogo: 'https://dglstorage.com/files/sportilink/images/club.png',
  
  // Tournament
  tournamentNameMinLength: 3,
  tournamentNameMaxLength: 50,
  tournamentDescriptionMaxLength: 1000,
  defaultTournamentThumbnail: 'https://dglstorage.com/files/sportilink/images/tournament.png',
  defaultTournamentMaxPlayers: 32,
  defaultSpectatorsLimit: 100,

  maxTournamentBracketParticipants: 128,

  // Official tournament payment instruction (admin-authored rich text/HTML)
  officialTournamentPaymentInstructionMaxLength: 8000,

  // Tournament Team
  tournamentTeamNameMinLength: 3,
  tournamentTeamNameMaxLength: 50,

  // Sponsor
  sponsorCompanyNameMinLength: 3,
  sponsorCompanyNameMaxLength: 100,
  sponsorDescriptionMaxLength: 1000,
  tournamentSponsorRequirementsMaxLength: 2000,
  tournamentSponsorPitchMaxLength: 500,
  maxSponsorLogoSizeBytes: 2 * 1024 * 1024, // 2MB

  // Event
  eventNameMinLength: 3,
  eventNameMaxLength: 50,
  eventDescriptionMaxLength: 1000,
  defaultEventThumbnail: 'https://dglstorage.com/files/sportilink/images/event.png',
  defaultEventImage: 'https://dglstorage.com/files/sportilink/images/event.png', // Added for consistency

  // Chat
  defaultChatThumbnail: 'https://dglstorage.com/files/sportilink/images/chat.png',
  maxChatMessageLength: 10000,
  /** @deprecated use chatRoomsTake or chatMessagesTake */
  chatDataTake: 20,
  /** Page size for the chat room list */
  chatRoomsTake: 20,
  /** Page size for message history pagination */
  chatMessagesTake: 20,

  // For bot crawlers
  defaultLatitute: -6.200000,
  defaultLongitude: 106.816666,

  // Sport preferences notification
  sportTypePreferenceNotificationRadius: 20000, // 20000 meters (20 km)

  // Featured listings
  maxDistanceForFeaturedListing: 50000, // 50000 meters (50 km)

  // Marketplace
  maxMarketplaceImages: 5,

  // Profile picture — cropped to a square of this edge length before upload.
  // Square because every surface that renders it (avatars, the Meet card
  // photo) is 1:1, so a non-square source would be cropped uncontrollably.
  profilePictureSize: 500,

  // Meet
  meetDescriptionMaxLength: 500,
  meetDeckPageSize: 20,
  meetDailyLikeLimit: 100,
  meetMinInterests: 1,
  meetMinDistanceKm: 5, // km — distances at/under this are reported as exactly this value ("within 5 km")

  // Session Seeker
  sessionSeekerMinDistanceKm: 5, // km — floor; distances at/under this are reported as exactly this value
  sessionSeekerDefaultDistanceKm: 20, // km — default "within distance"
  sessionSeekerMaxDistanceKm: 100, // km — upper clamp
  sessionSeekerListPageSize: 20,
  sessionSeekerNotifyMaxCandidates: 1000,
  sessionSeekerMinSportTypes: 1,
  sessionSeekerMinLevels: 1,

  // Club Seeker
  clubSeekerMinDistanceKm: 5, // km — floor; distances at/under this are reported as exactly this value
  clubSeekerDefaultDistanceKm: 20, // km — default "within distance"
  clubSeekerMaxDistanceKm: 100, // km — upper clamp
  clubSeekerListPageSize: 20,
  clubSeekerNotifyMaxCandidates: 1000,
  clubSeekerMinSportTypes: 1,
  clubSeekerMinLevels: 1,

  // Invitations (club & session)
  invitationSearchPageSize: 20, // username-search results per page
  invitationInboxPageSize: 20, // invitee inbox invites per page
  invitationSearchMinChars: 2, // min query length before username search runs
  invitationSearchMaxChars: 64, // cap query length (ReDoS guard)
  invitationSentReflectLimit: 500, // cap rows returned by the admin "already invited" reflection
  homeAttentionInvitesLimit: 50, // cap the pending-invite count surfaced in the attention strip

  // Reports
  REPORT_REASONS: [
    'Inappropriate images',
    'Scam',
    'Criminal Activities',
    'Rude members',
    'Others',
  ] as const,
  REPORT_THRESHOLD: 3, // Threshold for admin notification AND UI highlighting

  // Feedback & bug reports
  FEEDBACK_TYPES: ['feedback', 'bug'] as const,
  maxFeedbackImages: 5,
  feedbackMessageMaxLength: 3000,
  feedbackReplyMaxLength: 3000,
  feedbackPageSize: 20,

  // Leaderboard
  leaderboardCacheTime: 5 * 60 * 1000, // 5 minutes
  leaderboardRadiusOptions: [20, 50, 100, 1000, 10000] as const, // km
  // Normal users (REGISTERED only) can see up to this radius. Larger radii
  // (1000, 10000 km) are restricted to admins/owners (ADMIN role).
  leaderboardMaxNormalRadius: 100, // km
  leaderboardMinMatches: 5,
  leaderboardPageSize: 20,
  leaderboardPriorWins: 10,
  leaderboardPriorMatches: 20,

  // SportiRank (ELO-based skill rating)
  sportiRankInitialRating: 1000,
  sportiRankKFactor: 32,
  sportiRankMinRatedMatches: 3, // minimum rated matches to appear on leaderboard
  sportiRankAntiGrindWindowMs: 7 * 24 * 60 * 60 * 1000, // 7-day rolling window
  sportiRankAntiGrindMaxMatches: 3, // after this many matches vs same opponent in window, K = 0

  // Weekly Digest
  weeklyDigestRadius: 50000, // 50km in meters

  // Activity Feed & Follow
  activityFeedPageSize: 20,
  activityFeedMaxAgeDays: 30,
  followListPageSize: 20,

  // Keep-Alive
  mailWarmThresholdMs: 10 * 1000, // 10 seconds - triggers alert if mail server takes longer
  sendMailTimeoutMs: 15 * 1000, // 15 seconds - timeout for email sending before returning error to user

  // SMTP Retry
  smtpMaxRetries: 2, // max retry attempts on transient failures (ETIMEDOUT, ECONNRESET, etc.)
  smtpRetryDelayMs: 3 * 1000, // 3 seconds base delay between retries

  // Weekly recurring sessions
  // Delay after a recurring session's endAt before the owner is reminded
  // to renew it (detail prompt, list banner, and on-device notification).
  recurringRenewalDelayMs: 24 * 60 * 60 * 1000, // 24 hours

  // Delay after a session's endAt before members are reminded (on-device) to view the session summary
  sessionSummaryNotifyDelayMs: 60 * 60 * 1000, // 1 hour

  // Temporary image cleanup
  receiptRetentionDays: 14,
  temporaryImageCategories: [
    { folder: 'images/receipts', retentionDays: 14 },
  ] as { folder: string; retentionDays: number }[],

  // Official Tournaments — host KYC + activation receipt uploads
  maxHostVerificationDocuments: 5,
  maxActivationReceiptSizeBytes: 2 * 1024 * 1024, // 2MB
  maxHostVerificationDocSizeBytes: 2 * 1024 * 1024, // 2MB

  // Host KYC — phone/email verification codes (business profile confirmation)
  hostVerificationCodeExpiration: 10 * 60 * 1000, // 10 minutes
  hostVerificationCodeResendCooldown: 60 * 1000, // 1 minute
  hostVerificationCodeMaxAttempts: 5,

  // Ops — error capture (capped collection, see server/entities/ops-event.ts)
  opsEventsCappedSizeBytes: 50 * 1024 * 1024, // 50MB hard ceiling; Mongo evicts oldest-first
  opsEventsRateLimitMaxPerMinute: 60, // in-process flood guard for 5xx capture; overflow counted in droppedCount
  // Separate, smaller budget for unhandledRejection capture. It gets its own window so an
  // HTTP error storm can never exhaust the budget a crash record needs — a storm is exactly
  // when a crash is most likely. It is capped at all because the process deliberately keeps
  // running after an unhandled rejection, and one broken async path can emit one per request.
  // uncaughtException is never rate limited (it exits the process; see ops-event-recorder.ts).
  opsEventsProcessRateLimitMaxPerMinute: 10,
  opsEventsRateLimitWindowMs: 60 * 1000, // window length, shared by both limiters above
  opsEventsPulseWindowMs: 24 * 60 * 60 * 1000, // "last 24h" window used by the pulse/brief
  opsEventsTopPathsLimit: 5,
  opsEventsMessageMaxLength: 500, // truncate stored error messages; never a full stack trace
  // Daily brief goes RED when 5xx count in the last 24h exceeds this.
  opsEventsBriefRedThreshold: 20,

  // Home page: Next-Up card + Needs-Attention strip
  // Per-source cap when fetching upcoming sessions/tournaments/events before
  // merging & sorting them into a single "next up" list.
  homeNextUpPerSourceLimit: 5,
  // Final size of the merged, sorted "next up" list returned to the client.
  homeNextUpTopN: 5,
  // Bound on pending challenge invites shown in the attention strip.
  homeAttentionPendingChallengesLimit: 20,
  // Lookback window for "unrated past matches": only sessions that ended
  // within this many days are eligible to nudge the user to rate them.
  homeAttentionUnratedSessionsLookbackDays: 14,
  // Bound on unrated-session candidates considered (pre-lookup) and returned.
  homeAttentionUnratedSessionsCandidateLimit: 50,
  homeAttentionUnratedSessionsLimit: 20,
  // Bound on outstanding-payment rows shown in the attention strip.
  // Payment.getMyOutstandingCounts() itself has no $limit (it also backs
  // GET /payments/my-outstanding, whose behavior must not change), so the
  // cap is applied here on the mapped items instead.
  homeAttentionOutstandingPaymentsLimit: 20,
};
